import { render } from 'preact';
import { AppShell } from './ui/AppShell';
import { createGame } from './game';
import './ui/styles.css';

// Hide the boot splash once everything is mounted.
function hideBoot() {
  const boot = document.getElementById('boot');
  if (boot) boot.style.display = 'none';
}

function mount() {
  const gameRoot = document.getElementById('game');
  const overlayRoot = document.getElementById('overlay');
  if (!gameRoot || !overlayRoot) {
    console.error('Missing #game or #overlay roots');
    return;
  }

  // Mount Phaser into #game.
  createGame(gameRoot);

  // Mount Preact overlay into #overlay (transparent div above the canvas).
  render(<AppShell />, overlayRoot);

  hideBoot();
}

// Register the service worker (PWA installability).
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/sw.js').catch(() => { /* dev-server may not serve sw — ignore */ });
}

mount();
